import { createRouter, createWebHashHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../components/Home.vue'),
  },
  {
    path: '/:id',
    name: 'HomeWithId',
    component: () => import('../components/Home.vue'),
    props: (route) => ({ id: route.params.id }),
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})


export default router


